import _ from 'lodash'

import { ZENDESK_AUTHENTICATION_SUCCESS, ZENDESK_AUTHENTICATION_FAILED } from 'actions'

const initialState = {
  zendesk: {
    isFailedAuthenticated: false,
  },
}

const integrationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ZENDESK_AUTHENTICATION_SUCCESS: {
      return _.merge({}, state, {
        zendesk: {
          isFailedAuthenticated: false,
        },
      })
    }
    case ZENDESK_AUTHENTICATION_FAILED: {
      return _.merge({}, state, {
        zendesk: {
          isFailedAuthenticated: true,
        },
      })
    }
    default:
      return state
  }
}

export default integrationsReducer



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/pages/integrations/index.js